import { EServiceId } from '../../../../redux/reducers';
import { ITermSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { getServiceId } from '../../../../utils/publishTerms';

export function getSelectedServiceId(terms: ITermSchema[]): EServiceId | null {
  const defaultService = terms.find(({ isDefault }) => isDefault);

  return defaultService ? getServiceId(defaultService.services) : null;
}
